import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const PieChart18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.99989 0.25C8.5857 0.250029 8.24994 0.585807 8.24994 1V9C8.24994 9.52951 8.80972 9.89816 9.29617 9.68902L16.6462 6.52902C17.0117 6.37189 17.1961 5.90923 17.039 5.54375C16.3632 3.9721 15.2415 2.63302 13.8127 1.69214C12.3839 0.75127 10.7107 0.249882 8.99989 0.25ZM9.74994 7.86117V1.78884C10.9027 1.90863 12.0138 2.30353 12.9878 2.94492C13.9618 3.58629 14.7635 4.45099 15.3289 5.46258L9.74994 7.86117Z'
      fill='currentColor'
    />
    <path
      d='M7.2104 3.0087L6.78151 1.57132C4.00155 2.40081 1.87474 4.78936 1.36882 7.64555C0.587552 12.0562 3.85079 16.3248 8.31481 16.7183C13.2196 17.1507 16.9981 12.8651 16.7376 8.14866L15.2399 8.23136C15.4487 12.0132 12.4659 15.5784 8.44653 15.2241C4.84652 14.9068 2.21584 11.4638 2.84583 7.90717C3.25379 5.60398 4.9686 3.67761 7.2104 3.0087Z'
      fill='currentColor'
    />
  </Svg>
);

PieChart18.displayName = 'PieChart18';
export default PieChart18;
